import { Project } from "@microtica/ms-project-sdk";
import { CreditCardOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Col, Row, Space } from "antd";
import { useNavigate, useOutletContext } from "react-router";
import GridList from "../../components/GridList";
import CardMarketing from "../../components/marketing/CardMarketing";
import ExplanationButton from "../../components/explanations/ExplanationButton";
import ProjectExplanation from "../../components/explanations/ProjectExplanation";

export default function Projects() {
    const navigate = useNavigate();
    const { projects } = useOutletContext<{ projects: Project[] }>();

    return (
        <Space direction="vertical" size="large" className="full-width">
            {!!projects.length &&
                <Row gutter={24}>
                    <Col xs={24} sm={12} md={6}>
                        <h3>
                            Projects
                            <ExplanationButton
                                content={<ProjectExplanation />}
                            />
                        </h3>
                    </Col>
                </Row>
            }
            <GridList
                itemsInRow={3}
                disableEmptyState={true}
                dataSource={projects.map(project => ({
                    key: project.id,
                    title: project.name,
                    description: project.description,
                    tags: [
                        {
                            position: "bottom",
                            value:
                                <Space>
                                    <CreditCardOutlined />
                                    {project.paymentPlan?.name}
                                </Space>
                        },

                    ],
                    link: `/projects/${project.id}`
                }))}
            />
            {
                projects.length === 0 ?
                    <CardMarketing
                        title="With Microtica, everyone gets more done"
                        subtitle="Choose from our Developer self-service plans"
                        description="Spin up environments with ready-made infrastructure components, deploy apps on Kubernetes and support your production workloads with our additional features."
                        action={
                            <Button
                                onClick={() => {
                                    navigate("/pricing/new");
                                }}>
                                <PlusCircleOutlined /> Create Project
                            </Button>
                        }
                    />
                    :
                    // dont display anything from this section if user has projects
                    null
            }
        </Space>
    )
}